import styled from '../../../src/constants/theme'
import { responsivePaddingStyles } from '../../../styles'

export const PageHeader = styled.h1<{ textLight?: boolean }>(
  {
    fontSize: 32,
    fontWeight: 'normal',
    textAlign: 'center',
  },
  ({ textLight, theme }) => ({
    ...responsivePaddingStyles(theme),
    color: textLight ? theme.textLight : theme.text,
  }),
)
